import React from 'react';
import { Box, Button } from '@mui/material';
import { useThemeColors } from '../../../utils/useThemeColors';

// Docked, always-visible alternative to the floating nav menus. Same section
// ids as Small/Large floating menus so it shares disabledSections/hiddenSections
// and works for both windows (ww.js) and patio doors (pd.js — wired later).
// Patio doors hide the Top Row entries via hiddenSections.
const SECTION_ITEMS = [
  { id: 'Configuration', label: 'Configuration', tooltip: 'Window Configuration' },
  { id: 'SizingAndFrameTop', label: 'Sizing & Frame - Top', tooltip: 'Sizing & Frame - Top Row' },
  { id: 'GrillsTop', label: 'Grills - Top', tooltip: 'Grills - Top Row' },
  { id: 'SizingAndFrame', label: 'Sizing & Frame', tooltip: 'Sizing & Frame - Main Row' },
  { id: 'Grills', label: 'Grills', tooltip: 'Grills - Main Row' },
  { id: 'Glass', label: 'Glass', tooltip: 'Glass' },
  { id: 'Finish', label: 'Finish', tooltip: 'Finish' },
  { id: 'AdditionalItems', label: 'Additional Items', tooltip: 'Additional Items' },
  { id: 'Installation', label: 'Installation', tooltip: 'Installation' },
  { id: 'Notes', label: 'Notes', tooltip: 'Notes' },
  { id: 'Discounts', label: 'Quantity & Discounts', tooltip: 'Quantity & Discounts' },
];

const TopBarNavMenu = ({
  menuItems = SECTION_ITEMS,
  selectedSectionId,
  showOnlySelected,
  disabledSections = {},
  hiddenSections = [],
  onSelectSection,
  onViewAll,
  onUndock,
}) => {
  const tc = useThemeColors();
  const visibleItems = menuItems.filter(item => !hiddenSections.includes(item.id));

  const btnSx = (extra = {}) => ({
    fontSize: '12px',
    textTransform: 'none',
    minHeight: '26px',
    borderRadius: '4px',
    px: 1.2,
    color: tc.text,
    '&:hover': { backgroundColor: tc.buttonHover },
    ...extra,
  });

  return (
    <Box
      sx={{
        backgroundColor: tc.panelBg,
        border: `1px solid ${tc.panelBorder}`,
        borderRadius: '8px',
        boxShadow: '0 2px 6px rgba(0,0,0,0.12)',
        p: '4px',
        mb: 0.5,
        display: 'flex',
        flexWrap: 'wrap',
        gap: '4px',
        alignItems: 'center',
      }}
    >
      {visibleItems.map(item => {
        const isDisabled = !!disabledSections[item.id];
        const isActive = showOnlySelected && selectedSectionId === item.id;
        return (
          <Button
            key={item.id}
            className="nav-button"
            onClick={() => !isDisabled && onSelectSection(item.id)}
            disabled={isDisabled}
            sx={btnSx({
              backgroundColor: isActive ? tc.buttonBgSelected : tc.buttonBg,
              color: isDisabled ? tc.textDisabled : tc.text,
              opacity: isDisabled ? 0.4 : 1,
            })}
          >
            {item.label}
          </Button>
        );
      })}

      <Button
        className="nav-button"
        onClick={onViewAll}
        sx={btnSx({
          fontWeight: 600,
          backgroundColor: !showOnlySelected ? tc.buttonBgToggleOn : tc.buttonBgToggleOff,
        })}
      >
        View all
      </Button>

      {onUndock && (
        <Button
          className="nav-button"
          onClick={onUndock}
          title="Switch to floating menu"
          sx={btnSx({
            minWidth: '34px',
            fontSize: '15px',
            ml: 'auto',
            backgroundColor: tc.headerBg,
            '&:hover': { backgroundColor: tc.headerHover },
          })}
        >
          ⤢
        </Button>
      )}
    </Box>
  );
};

export default TopBarNavMenu;
